<template>
	<div id="reporte1" class="container">
		<h2>Contratos Reporte </h2>

		<input id='abusca' type='text' placeholder='Buscar' v-model='abuscar' >
	 	<button v-on:click="imprimir('reporte1')">Impresión</button>

		<ul id='contratos-lista' v-if="contratosTodos !=null" >
  			<table >
			    <thead>
					<tr>
						<th>Contrato			
	 					<button v-on:click="ordenar(0,'registros')">&#9653;</button>
	 					</th>
						<th>Propiedad
	 					<button v-on:click="ordenar(1,'registros')">&#9653;</button>
	 					</th>
						<th>Inquilino
	 					<button v-on:click="ordenar(2,'registros')">&#9653;</button>
	 					</th>
						<th>Nombre
	 					<button v-on:click="ordenar(3,'registros')">&#9653;</button>
	 					</th>						
	 					<th>Giro
	 					<button v-on:click="ordenar(4,'registros')">&#9653;</button>
	 					</th>						
	 					<th id='ren'>Renta/mes
	 					<button v-on:click="ordenar(5,'registros')">&#9653;</button>
	 					</th>						
	 					<th>Modificado
	 					<button v-on:click="ordenar(6,'registros')">&#9653;</button>
	 					</th>
	 					<th>Por
	 					<button v-on:click="ordenar(7,'registros')">&#9653;</button>
	 					</th>	 					
					</tr>
				</thead>

				<tbody  id='registros'>
					<tr v-for="contrat in buscando" v-on:click="seleccion(contrat.id)">

						<td>{{contrat.id}} </td>
						<td>{{contrat.propiedad}} </td>
						<td>{{contrat.inquilino}} </td>
						<td>{{contrat.nombreComercial}} </td>
						<td>{{contrat.giro}} </td>
						<td id='imp' v-if:contrat.importeMes >{{contrat.importeMes  | FormateaNumero }} </td>					
						<td v-if:contrat.fechaModificacion >{{contrat.fechaModificacion | FormateaFecha(contrat.fechaModificacion) }} </td>
						<td>{{contrat.quienModifico}} </td>

					</tr>
				</tbody>
				<tfoot>
					<tr>
							<td><strong>TOTAL {{cuentalos}}</strong></td>	
							<td></td>	
							<td></td>		
							<td></td>		
							<td></td>		
							<td><strong>TOTAL {{lasuma(buscando) | FormateaNumero }}</strong></td>
					</tr>
 				</tfoot>

			</table>
		</ul>
		<span v-else>Cargando contratos...</span>
	</div>
</template>

<script>
import axios from 'axios';

export default { 
  name: 'Contratos',

  mounted(){
  	this.getContratos();
  },
  data () {
    return {
      contratosTodos: [],
      abuscar: '',
    }
  },

  methods:{
  	getContratos(){
  		axios.get('https://www.directodo.com/Rentus/accesosdb/leeContratos.php')
  		     .then((respuesta) => {
  		     	this.contratosTodos = respuesta.data;
  			 });
  	},
	lasuma: function (arreglo) {
   		var sum2 = arreglo.reduce(function(prevVal, elem) {
				return prevVal + parseFloat(elem.importeMes);
		}, 0);
		return sum2;
	},	

  	seleccion: function (id){
  		return 0;
  	}, 	  	
  	imprimir: function(divName) {
	     var printContents = document.getElementById(divName).innerHTML;
	     var originalContents = document.body.innerHTML;
	     document.body.innerHTML = printContents;
	     window.print();
	     document.body.innerHTML = originalContents; 
	},
 	ordenar: function (n, donde){
		var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
		table = document.getElementById(donde);
		switching = true;
		dir = "asc"; 

		while (switching) {
		    switching = false;
		    rows = table.getElementsByTagName("TR");
			var esNumero = true;
			var esFecha = false;
			var esFechaM = false;
			var esFechaD = false;
			var date1 = new Date(); 
			var miliseg1 = 0;
			var date2 = new Date();  
			var miliseg2 =0 ;			

		    for (i = 0; i < (rows.length - 1); i++) {
			    shouldSwitch = false;
			    x = rows[i].getElementsByTagName("TD")[n];
			    y = rows[i + 1].getElementsByTagName("TD")[n];
			      
			    'DETERMINA SI ES NUMERO O LETRAS'
			    var elemento1 = x.innerHTML.toLowerCase();
			    var elemento2 = y.innerHTML.toLowerCase();

			    'QUITAS COMAS Y PUNTOS PARA COMPARAR SOLO NUMEROS EN SU CASO'
				var sinComas1 = elemento1.replace(',','');
		   		var sinComas2 = elemento2.replace(',','');

			    esNumero = true;
			    if (isNaN(sinComas1) || isNaN(sinComas2)) {
			      	esNumero = false;
			    } 

		      	if (esNumero){		 
				    if (dir == "asc") {
				        if (parseFloat(sinComas1) > parseFloat(sinComas2)) {
				          	shouldSwitch= true;
				          	break;
				        }
				      } else if (dir == "desc") {
				        if (parseFloat(sinComas1) < parseFloat(sinComas2)) {
				          	shouldSwitch= true;
				          	break;
				        }
				      }
				}else{ 'NO ES NUMERO'

					'ES FECHA ?'
					esFecha= false;
					if (2==2){
						esFecha= true;
					}


					if (esFecha){
						'ES FECHA'
						console.log('es fecha' + elemento1);

						 date1 = new Date(elemento1); 
						 miliseg1 = date1.getTime();
						 date2 = new Date(elemento2); 
						 miliseg2 = date2.getTime();

						if (dir == "asc") {
					        if (miliseg1 > miliseg2) {
					          	shouldSwitch= true;
					          	break;
					        }
					    } else if (dir == "desc") {
					        if (miliseg1 < miliseg2) {
					          	shouldSwitch= true;
					          	break;
					        }
					    }

					}else{
						'NO ES FECHA'
						console.log('no es fecha');
					    if (dir == "asc") {
					        if (elemento1 > elemento2) {
					          	shouldSwitch= true;
					          	break;
					        }
					     } else if (dir == "desc") {
					        if (elemento1 < elemento2) {
					          	shouldSwitch= true;
					          	break;
					        }
					    }
					}   
				}
		    }

		    if (shouldSwitch) {
		      	rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
		      	switching = true;
		      	switchcount ++; 
		    } else {
		      	if (switchcount == 0 && dir == "asc") {
		        	dir = "desc";
		        	switching = true;
		      	}
		    }
		}
	}  	
  },

  filters: {
        Upper(value) {
            return value.toUpperCase();
        },
        FormateaNumero (valor1) {
            return (Number(valor1)).toLocaleString('en-US', {minimumFractionDigits: 2, useGrouping:true});
        },
        FormateaFecha (fecha) {
        	var d = new Date(fecha); 
        	if (Date.parse(d)){
        		d = new Intl.DateTimeFormat('en-US').format(d);
        		return d} 
        	else{return "sin fecha";}			
        },

  },  

  computed:{
	 	buscando: function (){
	 		this.tot= 0;
	  		return this.contratosTodos.filter((item) => item.propiedad.includes(this.abuscar) || item.inquilino.includes(this.abuscar));
	  	},
	  	cuentalos: function (){
	  		return this.buscando.length;
	  	}  	
  }

}
</script>

</style>




// WEBPACK FOOTER //
// src/Contratos-reporte.vue